<div class="ui input currency-input" [class.error]="error" [class.disabled]="disabled">
  <input type="number" [min]="0" [ngModel]="value" (ngModelChange)="setValue($event)" (focusout)="onFocusOut()" />
  <span *ngIf="showCurrency" class="currency-label">
    {{ currency }}
  </span>
</div>
